import { MultiSelect } from '@empathy/search-types';
import { COMPONENTS, DeepPartial, FacetsConfig, SLOTS } from '@empathybroker/ebx-gluon';

export const MOBILE_FACETS_CONFIG: DeepPartial<FacetsConfig> = {
  default: {
    facet: {
      components: {
        icon: COMPONENTS.PURE.ChevronUpIcon
      }
    }
  },
  facets: {
    hierarchical_category: {
      components: {}
    },
    color_facet: {
      components: {
        filter: {
          checkbox: 'GoccoColorFilter'
        }
      },
      showMoreButton: null,
      mapping: { multiSelectable: MultiSelect.OnFrontend }
    }
  },

  groups: {
    'all-facets': {
      collapsible: true,
      templateSlots: {
        panel: SLOTS.template.overlay,
        toggle: SLOTS.template.footer
      },
      facets: {
        sizes_facet: {},
        color_facet: {},
        price_facet: {}

      },
      slidingDirection: 'bottom',
      components: {
        toggleIcon: COMPONENTS.PURE.ChevronUpIcon,
        header: 'GoccoFacetsHeader',
        clear: null
      }
    },
    'categories-facet-group': {
      components: {
        panel: COMPONENTS.PANELS.SlidingPanel,
        toggle: null
      },
      facets: {
        hierarchical_category: {
          components: {
            filters: 'GoccoFilterHorizontal'
          }
        }
      },
      slots: {
        clear: SLOTS.facetsGroup.footer
      },
      templateSlots: {
        panel: SLOTS.template.toolbar
      },
      collapsible: false

    }
  }
};

export const DESKTOP_FACETS_CONFIG: DeepPartial<FacetsConfig> = {
  default: {
    facet: {
      showMoreButton: false,
      filtersToShow: 10,
      startCollapsed: false,
      components: {
        selectedFilters: {
          filterTitle: 'GoccoSelectedFilter'
        }
      }
    }
  },
  facets: {
    price_facet: {
      mapping: { multiSelectable: MultiSelect.OnFrontend }
    },
    color_facet: {
      mapping: { multiSelectable: MultiSelect.OnBackend }
    },
    sizes_facet: {
      mapping: { multiSelectable: MultiSelect.OnFrontend }
    }
  },
  groups: {
    'all-facets': {
      collapsible: true,
      facets: {
        sizes_facet: {},
        color_facet: {},
        price_facet: {}
      },
      layoutDirection: 'vertical',
      startCollapsed: false,
      components: {
        selectedFilters: {
          selectedFilters: COMPONENTS.PURE.SelectedFilters
        },
        clearIcon: COMPONENTS.PURE.CrossIcon,
        toggleIcon: COMPONENTS.PURE.ChevronLeftIcon

      },
      templateSlots: {
        toggle: SLOTS.template.toolbar
      },
      slots: {
        close: null,
        selectedFilters: SLOTS.facetsGroup.header,
        clear: SLOTS.facetsGroup.header
      }

    },
    'categories-facet-group': {
      components: {
        panel: COMPONENTS.PANELS.SlidingPanel,
        toggle: null

      },
      facets: {
        hierarchical_category: {
          components: {
            filters: 'GoccoFilterHorizontal'
          }
        }
      },
      slots: {
        clear: SLOTS.facetsGroup.footer
      },
      templateSlots: {
        panel: SLOTS.template.toolbar
      },
      collapsible: false
    }
  }
};
